export const HeaderData = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "about us",
    path: "/about-us",
    heading: "Learn About Us",
  },
  {
    title: "services",
    path: "#",
    subNav: [
      {
        subTitle: "our services",
        heading: "What We Do",
        path: "/our-services",
      },
      {
        subTitle: "services details",
        heading: "Construction Service",
        path: "/our-services/services-details",
      },
    ],
  },
  {
    title: "projects",
    path: "#",
    subNav: [
      {
        subTitle: "our projects",
        heading: "Recenty We Work Done",
        path: "/our-projects",
      },
      {
        subTitle: "project details",
        heading: "A vibrant new landmark for the USA",
        path: "/our-projects/project-details",
      },
    ],
  },
  {
    title: "Pages",
    path: "#",
    subNav: [
      
      {
        subTitle: "our team",
        heading: "Meet Our Awesome Team",
        path: "/our-team",
      },
      {
        subTitle: "our team details",
        heading: "Meet Our Member",
        path: "/our-team/our-team-details",
      },
      
      {
        subTitle: "testimonial",
        heading: "What Our Clients Say About Us",
        path: "/testimonial",
      },
      {
        subTitle: "pricing plan",
        heading: "Simple, Transparent Pricing",
        path: "/pricing-plan",
      },
   
      {
        subTitle: "faq",
        heading: "Frequently Asked Questions",
        path: "/faq",
      },
      {
        subTitle: "error 404",
        path: "/error-404",
      },
      {
        subTitle: "coming soon",
        path: "/coming-soon",
      },
    ],
  },
  {
    title: " Our Blogs",
    path: "#",
    subNav: [
      {
        subTitle: "our blogs",
        heading: "Our News and Blogs",
        path: "/our-blogs",
      },
      {
        subTitle: "blog details",
        heading: "Our News and Blogs",
        path: "/our-blogs/blog-details",
      },
    ],
  },
  {
    title: "contact us",
    path: "/contact-us",
    heading: "Get in Touch With Us",
  },
];
